<script setup lang="ts">
    import type { AvailableLabels } from '~/types';

    const props = defineProps({
        label: {
            type: String,
            required: true,
        },
        noHover: {
            type: Boolean,
            default: false,
        },
    });

    const label = props.label as AvailableLabels;

    const labelToLogoMapping: Record<AvailableLabels, string> = {
        // Requested for wetgoods
        'Nordic Ecolabel': 'svanen.svg',
        'EU Ecolabel': 'eu-ecolabel.svg',
        M1: 'm1.png',
        'Asthma Allergy Nordic': 'aan.png',

        // Requested for drygoods
        'FSC 100': 'fsc-100.svg',
        'FSC Mix Credit': 'fsc-mix-credit.svg',
        '100 % PCR Plastic': '100-pcr.png',
    };

    const image = labelToLogoMapping[label] || false;

    const path = '/labels/' + image;
</script>

<template>
    <img
        v-if="image"
        :src="path"
        :alt="props.label"
        :title="props.label"
        class="relative h-auto w-16 object-contain saturate-50 hover:saturate-100"
    />
</template>
